module.exports = __webpack_public_path__ + "img/game.0cec8deb.svg";